if (typeof UGCFeed === 'undefined') {
    class UGCFeed extends HTMLElement {
        connectedCallback() {

            const swiperContainer = this.querySelector('.swiper');
            if (!swiperContainer || this.swiper) return;

            whenReady('Swiper', () => {
                try {
                    this.swiper = new Swiper(swiperContainer, {
                        loop: true,
                        a11y: true,
                        slidesPerView: "auto",
                        spaceBetween: 10, 
                        mousewheel: {
                            forceToAxis: true,
                            thresholdDelta: 12
                        },
                        navigation: {
                            nextEl: this.querySelector('.swiper-next'),
                            prevEl: this.querySelector('.swiper-prev'),
                        },
                        modules: [Swiper.A11y, Swiper.Navigation, Swiper.Mousewheel],
                        on: {
                            slideChange: () => {
                                this.querySelectorAll('video').forEach(video => {
                                    delete video.dataset.userUnmuted;
                                    video.muted = true;
                                });
                            }
                        }
                    });

                } catch (error) {
                    console.error('Failed to initialize Swiper:', error);
                }
            });
        }

        disconnectedCallback() {
            if (this.swiper) {
                this.swiper.destroy(true, true);
                this.swiper = null;
            }
        }

    }

    if (!window.customElements.get('ugc-feed')) {
        window.customElements.define('ugc-feed', UGCFeed);
    }
}